<template>
    <div class="aside">
        <div class="title">
            <div style="overflow: hidden;display: inline-block;line-height: 60px;">
                <img src="@/assets/logo.png" alt="" style="float: left;margin-right: 20px;">
                <span style="float: left;">广西公路学会</span>
            </div>
        </div>
        <el-menu class="el-menu-vertical-demo" background-color="#1e282c" text-color="#fff"
            :default-openeds="defaultOpend" active-text-color="#409eff">
            <template v-for="(item, index) in menu">
                <el-submenu :index="'' + index" v-if="item.children">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span>{{ item.name }}</span>
                    </template>
                    <el-menu-item v-for="(subItem, subIndex) in item.children" :key="subIndex"
                        :class="{ 'active': $route.name == subItem.path }" :index="index + '-' + subIndex"
                        @click="handleClick(subItem)">
                        <i class="el-icon-star-on"></i>
                        <span slot="title">{{ subItem.name }}</span>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item :index="'' + index" v-else @click="handleClick(item)"
                    :class="{ 'active': $route.name == item.path }">
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.name }}</span>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
</template>

<script>

export default {
    data() {
        return {
            active: "dashboard",
            menu: [],
            defaultOpend: []
        }
    },
    created() {
        const userInfo = sessionStorage.getItem("admninUserInfo") && JSON.parse(sessionStorage.getItem("admninUserInfo"))
        const modules = userInfo.modules
        let noParentMenu = [
            { name: "数据看板", id: "dashboard", path: "dashboard", icon: "el-icon-menu" },
            { name: "管理员管理", id: "account", path: "accountManagement", icon: "el-icon-user-solid" },
        ]
        let parentMenu = [
            { name: "单位会员", id: "qyuser", parentName: "会员管理", path: "membersInstitutional" },
            { name: "个人会员", id: "gruser", parentName: "会员管理", path: "membersPersonal" },
            { name: "个人会员统计", id: "grhytj", parentName: "会员管理", path: "statistics" },
            { name: "栏目管理", id: "cats", parentName: "内容管理", path: "contentManagementCats" },
            { name: "文章管理", id: "article", parentName: "内容管理", path: "contentManagementArticle" },
            { name: "链接管理", id: "links", parentName: "内容管理", path: "contentManagementLinks" },
        ]
        if (!userInfo.isSuperAdmin) {
            noParentMenu = noParentMenu.filter(el => modules.includes(el.id))
            parentMenu = parentMenu.filter(el => modules.includes(el.id))
        }
        const parentNames = [...new Set(parentMenu.map(el => el.parentName))]
        this.menu = noParentMenu.concat(parentNames.map((el, index) => {
            return {
                icon: index ? "el-icon-document-copy" : "el-icon-postcard",
                name: el,
                id: el,
                children: parentMenu.filter(item => item.parentName == el)
            }
        }))
        this.menu.forEach((el, index) => {
            if (el.children && el.children.length) {
                this.defaultOpend.push('' + (index))
            }
        })
    },
    methods: {
        handleClick(menu) {
            if (this.$route.name == menu.path) return
            this.$router.push({
                name: menu.path,
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.aside {
    position: absolute;
    width: 300px;
    top: 0;
    bottom: 0;
    background: #1e282c;

    .title {
        padding: 20px;
        color: #fff;
        font-size: 18px;
        font-weight: bold;

        img {
            width: 60px;
        }
    }

    .el-menu {
        border: none;
    }

    .active {
        color: #409eff !important;

        i {
            color: #409eff !important;
        }
    }
}
</style>